import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import {
	GuestPerimeterXConfig,
	type GuestPerimeterXConfigQuery,
	type GuestPerimeterXConfigQueryVariables,
} from './api.graphql';

export async function getGuestPerimeterXConfig(
	{ gql: { fetch } }: UtilityContext,
	email: string,
): Promise<GuestPerimeterXConfigQuery['guestPerimeterXConfig']> {
	const { data } = await fetch<GuestPerimeterXConfigQuery, GuestPerimeterXConfigQueryVariables>({
		query: GuestPerimeterXConfig,
		variables: { email },
		batched: false,
		rejectOnError: true,
	});
	return data.guestPerimeterXConfig;
}
